import React from 'react';

export const Loading = () => {
  return (
    <div className="relative flex items-center justify-center w-full h-screen">
      <span className="loader relative w-12 h-12 rounded-full" />
      <style>{`
        .loader {
          transform: rotateZ(45deg);
          perspective: 1000px;
          color: #fff;
        }
        .loader::before,
        .loader::after {
          content: '';
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          transform: rotateX(70deg);
          animation: spin 1s linear infinite;
        }
        .loader::after {
          color: primary;
          transform: rotateY(70deg);
          animation-delay: 0.4s;
        }

        @keyframes spin {
          0%, 100% {
            box-shadow: .2em 0px 0 0px currentcolor;
          }
          12% {
            box-shadow: .2em .2em 0 0 currentcolor;
          }
          25% {
            box-shadow: 0 .2em 0 0px currentcolor;
          }
          37% {
            box-shadow: -.2em .2em 0 0 currentcolor;
          }
          50% {
            box-shadow: -.2em 0 0 0 currentcolor;
          }
          62% {
            box-shadow: -.2em -.2em 0 0 currentcolor;
          }
          75% {
            box-shadow: 0px -.2em 0 0 currentcolor;
          }
          87% {
            box-shadow: .2em -.2em 0 0 currentcolor;
          }
        }
      `}</style>
    </div>
  );
};
